import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.css']
})
export class RegisterPageComponent implements OnInit {
 mobileNum = "";
 verif_hash = '';
 env = environment;
  con_pass = '';
  confirm_msg = '';
  user_detail: any = [];
  formObj: any = [];
 
  constructor(private apiService : ApiService, private appComponent : AppComponent, private router: Router) { }

  isUserReg = false;
  isverify = false;
  counter = 60;
  ngOnInit(): void {
  }



  register(data : any){
    this.formObj = data;
    this.mobileNum = data.mobile_no;
    console.log(this.formObj);
    this.genrateOtp();
  }

  confirmPass(pass: any){
    // console.log(pass);
    pass.form.controls.confirm_password.errors = null;
    // pass.form.controls.password.errors = null;

    if((pass.value.password != '') && (pass.value.confirm_password != '') && (pass.value.password != pass.value.confirm_password)){
      pass.form.controls.confirm_password.setErrors({ notMatch: true });
      // pass.form.controls.password.setErrors({ notMatch: true });
    }
  }

  genrateOtp(){
    const formObj = {
      mobile_no: this.mobileNum,
      ulb_id: this.env.ulb_id
    }
    this.apiService.postCitizenData(`send_otp`, formObj).subscribe(
      (res: any) => {
        if(res.success = true){
          this.isUserReg = true;
        }
        this.isverify = true;
        this.verif_hash = res.data.verification_hash;
        this.startTimer();
      },
      (error) =>{
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      });
  }

  verifyOtp(data : any){
    const formObj = {
      mobile_no: this.mobileNum,
      verification_hash: this.verif_hash,
      otp: data.otp
    }
    this.apiService.postCitizenData(`verify_mobile_no`, formObj).subscribe(
      (res: any) => {
        const product = res.data;
        this.isUserReg = false;
        // localStorage.setItem('loginDetails', JSON.stringify(res['data']));
        this.registeration();
      },
      (error) =>{
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      });
  }

  registeration(){
    const formValue = {
      name: this.formObj.name,
      mobile_no: this.formObj.mobile_no,
      password: this.formObj.password,
      email: this.formObj.email,
      verification_hash: this.verif_hash,
      ulb_id: this.env.ulb_id
    }
    this.apiService.postCitizenData(`register_citizen`, formValue).subscribe(
      (res: any) => {
        const _data = {user : [res.data], token : res.token};
        localStorage.setItem('loginDetails', JSON.stringify(_data));
        this.router.navigate(['/user-property-list']);
      },
      (error) => {
        this.appComponent.showMessageAlert(error.error.message, 'error');
        this.startTimer();
      }
    );
  }
  
  startTimer(){
    this.counter = 60;
    let _interval = setInterval(val => {
       this.counter = +(this.counter - 1);
       if(this.counter == 0) {
         clearInterval(_interval);
       }
     }, 1000);
   }
 

}